import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/conclusionmbs.webp';
import screenshot_target from '../../../images/letterfunnel/renealtena.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Rene Altena"
      firstname="Rene"
      companyname="Conclusion MBS"
      competition="Fellowmind en Cegeka"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/renealtena.js